/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {UserProfilePageComponent} from './user-profile-page.component';


export function userProfileStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
  states.add('app.adm.user-profile', {
    url: '/user-profile',
    data: {
      title: 'User Profile',
      app: ['ADVERTISING', 'DATA', 'POLITICAL']
    },
    views: {
      'content@app': {
        component: UserProfilePageComponent
      },
      'title@app': stateTitleView()
    }
  });
  return states.build();
}
